import React from 'react';

export function Hero({
  kicker,
  title,
  text,
  color = '#42d8ff',
  actions,
}: {
  kicker: string;
  title: string;
  text: string;
  color?: string;
  actions?: React.ReactNode;
}) {
  return (
    <section className="dp120-hero" style={{ ['--a' as string]: color }}>
      <span className="kicker">{kicker}</span>
      <h2>{title}</h2>
      <p>{text}</p>
      {actions ? <div className="dp120-hero-actions">{actions}</div> : null}
    </section>
  );
}

export function Kpis({ items }: { items: [string, string, string][] }) {
  const colors = ['#42d8ff', '#4ce2bf', '#f1b93f', '#9b7cff'];
  return (
    <div className="dp120-kpis">
      {items.map(([label, value, note], index) => (
        <article key={label} className="dp120-kpi" style={{ ['--k' as string]: colors[index % colors.length] }}>
          <small>{label}</small>
          <b>{value}</b>
          <span>{note}</span>
        </article>
      ))}
    </div>
  );
}

export function Card({
  title,
  sub,
  span = 'span6',
  children,
}: {
  title: string;
  sub?: string;
  span?: string;
  children: React.ReactNode;
}) {
  return (
    <article className={`dp120-card ${span}`}>
      <header>
        <div>
          <h3>{title}</h3>
          {sub ? <p>{sub}</p> : null}
        </div>
      </header>
      <div className="dp120-card-body">{children}</div>
    </article>
  );
}

export function Field({
  label,
  value,
  onChange,
  type = 'text',
  full = false,
  placeholder,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  full?: boolean;
  placeholder?: string;
}) {
  return (
    <label className={`dp120-field${full ? ' full' : ''}`}>
      <span>{label}</span>
      {type === 'textarea' ? (
        <textarea value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
      ) : (
        <input type={type} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
      )}
    </label>
  );
}

export function DocRow({
  title,
  note,
  file,
  onPick,
  onOpen,
}: {
  title: string;
  note?: string;
  file?: string | null;
  onPick?: (file: File) => void;
  onOpen?: () => void;
}) {
  return (
    <div className="dp120-doc">
      <div>
        <h4>{title}</h4>
        {note ? <p>{note}</p> : null}
        <div className="files">
          {file ? (
            <span className="dp120-filetag">{file.split('/').pop()}</span>
          ) : (
            <span className="dp120-badge warn">Не загружено</span>
          )}
        </div>
      </div>
      <div className="dp120-row-actions">
        {file && onOpen ? (
          <button type="button" className="dp120-mini" onClick={onOpen}>
            Открыть
          </button>
        ) : null}
        {onPick ? (
          <label className="dp120-mini mint">
            {file ? 'Заменить' : 'Загрузить'}
            <input
              className="dp120-hidden-file"
              type="file"
              onChange={(e) => {
                const picked = e.target.files?.[0];
                if (picked) onPick(picked);
              }}
            />
          </label>
        ) : null}
      </div>
    </div>
  );
}

export function SourceCard({
  title,
  text,
  links,
}: {
  title: string;
  text: string;
  links: [string, string][];
}) {
  return (
    <div className="dp120-source-card">
      <h4>{title}</h4>
      <p>{text}</p>
      <div className="dp120-source-links">
        {links.map(([label, href]) => (
          <a key={href} href={href} target="_blank" rel="noopener noreferrer">
            {label} ↗
          </a>
        ))}
      </div>
    </div>
  );
}
